import React from 'react';
import './SessionTimeoutPopup.css';
import axios from 'axios';
import { Modal } from 'carbon-components-react';
import { t } from '../RI18n';

class SessionTimeoutPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      reCheckTime: null,
      timeoutTime: 3600,
    };
    this.signal = axios.CancelToken.source();
  }

  componentDidMount() {
    setTimeout(() => {
      this.checkSession();
    }, this.props.initialReCheckTime * 1000);
  }

  run = () => {
    const tMultiplier = this.getCheckTime();
    setTimeout(() => {
      this.checkSession();
    }, tMultiplier * 1000);
  };

  checkSession = (
    refresh = false,
  ) => {
    if (window.requestInProgress) {
      this.setState({
        open: false,
      });
      this.run();
      return undefined;
    }

    return axios
      .get(
        `/session/current_timeout.json${
          refresh ? '' : '?background_poll=true'}`,
        {
          cancelToken: this.signal.token,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        },
      )
      .then((result) => this.handleNewTimeout(result, refresh))
      .catch((err) => {
        if (axios.isCancel(err)) return; // request aborted
        if ((!refresh && !err.response) // network error
            || (!refresh && err && err.response && err.response.status === 503)) {
          // import finalisation, database connection temporary unavailable
          this.state.timeoutTime -= this.state.reCheckTime || this.props.defaultReCheckTime;
          if (this.state.timeoutTime < 0) {
            this.handleNewSession();
          }
        } else {
          this.handleNewSession(); // in case of error log out
        }
        if (!refresh) {
          this.run();
        }
      });
  };

  setCheckTime = (timeoutTime, warningTime) => {
    if (timeoutTime > 0 && timeoutTime < this.props.defaultReCheckTime) {
      this.setState({ reCheckTime: timeoutTime });
    }

    if (
      warningTime > 0
      && warningTime < this.props.defaultReCheckTime
      && warningTime < timeoutTime
    ) {
      this.setState({ reCheckTime: warningTime });
    }

    if (timeoutTime > 0) {
      this.setState({ timeoutTime: timeoutTime + 1 });
    }
  };

  getCheckTime = () => {
    const returnTime = this.state.reCheckTime;

    if (returnTime === null) {
      return this.props.defaultReCheckTime;
    }

    this.setState({ reCheckTime: null });
    return returnTime;
  };

  handleNewTimeout = (result, refresh = false) => {
    const retTimeout = result.data.session_timeout * 1;
    const retTimeoutWarning = result.data.session_timeout_warning * 1;

    this.setCheckTime(retTimeout, retTimeoutWarning);

    if (retTimeoutWarning <= 0) {
      this.setState({
        open: true,
      });
    } else {
      this.setState({
        open: false,
      });
    }

    if (retTimeout < 0) {
      this.handleNewSession();
    }

    if (!refresh) {
      this.run();
    }
  };

  handleClickRefresh = () => {
    this.checkSession(true);
  };

  handleNewSession = () => {
    window.location.href = '/';
  };

  handleClickClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    if (this.state.open) {
      return (
        <Modal
          open
          modalHeading={this.props.appName}
          modalAriaLabel=""
          primaryButtonText={t('session.refresh')}
          secondaryButtonText={t('formtastic.cancel')}
          iconDescription={t('dialog.close')}
          onRequestClose={this.handleClickClose}
          onRequestSubmit={this.handleClickRefresh}
        >
          <p className="bx--modal-content__text">
            {t('session.expire_warning')}
          </p>
        </Modal>
      );
    }
    return null;
  }
}

export default SessionTimeoutPopup;
